<template>
  <transition
  name="jin-prevue-show"
  @leave="leave">
    <div
    v-show="visible"
    class="jin-prevue"
    :class="{'jin-empty': !list.length}"
    v-loading="isLoading"
    data-empty="暂无预告">
      <div class="jin-wrap jin-wrap-main">
        <div class="jin-prevue__wrap">
          <div class="jin-slider-wrap">
            <slick
            :options="slickOptions"
            ref="slick"
            v-if="isReady"
            class="jin-slider">
              <div
              v-for="(item, index) in list"
              :key="index"
              class="tv-prevue">
                <div class="tv-prevue__img" v-if="item.thumb">
                  <img :src="item.thumb" :alt="item.title">
                </div>
                <div class="tv-prevue__text">
                  <div class="tv-prevue__title">
                    <span>{{ filterDate(item.date) }}</span>
                    <h4>{{ item.title }}</h4>
                  </div>
                  <p>{{ item.room_name }}</p>
                </div>
              </div>
            </slick>
            <template v-if="isReady">
              <span class="jin-prevue__slider-button jin-slider-prev">
                <icon type="arrow-l"></icon>
              </span>
              <span class="jin-prevue__slider-button jin-slider-next">
                <icon type="arrow-r"></icon>
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { fetch } from '@/commons/fetch'
import { requestAttendUrl } from '@/commons/config'
import { dateFormat } from '@/commons/utils'
import Slick from '@/plugins/slick'

export default {
  name: '',
  components: {
    Slick
  },
  computed: {
    isReady () {
      return this.dataLoaded
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    $route () {
      this.list = []
      this.dataLoaded = false
    },
    visible (v) {
      this.$emit('input', v)
      if (v) {
        this.getDatas()
      }
    }
  },
  mounted () {
    this.getDatas()
  },
  data () {
    return {
      list: [],
      isLoading: false,
      dataLoaded: false,
      slickOptions: {
        autoplay: false,
        accessibility: false,
        infinite: true,
        arrows: true,
        prevArrow: '.jin-slider-prev',
        nextArrow: '.jin-slider-next',
        slidesToShow: 3,
        slidesToScroll: 3,
        speed: 300,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  methods: {
    getDatas () {
      if (this.isLoading) {
        return false
      }
      this.isLoading = true
      const type = this.$route.meta.type
      const params = type ? { type } : {}
      fetch({
        type: 'GET',
        url: requestAttendUrl.preview,
        headers: requestAttendUrl.headers,
        params,
        callback: () => {
          this.isLoading = false
          this.dataLoaded = true
        },
        success: ({ data }) => {
          this.list = data
          if (this.list.length) {
            this.$emit('update-prevue-show', true)
          }
        },
        error: () => {
          this.isLoading = false
        }
      })
    },
    filterDate (date) {
      let nowDate = dateFormat(new Date(), 'yyyy/MM/dd')
      let time = dateFormat(date, 'hh:mm')
      let oDate = dateFormat(date, 'yyyy/MM/dd')
      let days = ['今天', '明天']
      nowDate = new Date(nowDate).getTime()
      oDate = new Date(oDate).getTime()
      let diffDate = (oDate - nowDate) / (24 * 3600 * 1000)
      if (diffDate === 0 || diffDate === 1) {
        time = `${days[diffDate]} ${time}`
      } else if (diffDate > 1) {
        time = dateFormat(date, 'MM月dd日 hh:mm')
      }
      return time
    },
    leave () {
      // this.list = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// PrevueList.vue?e75eb01e